/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
import React from 'react';
import { Provider, defaultTheme } from '@adobe/react-spectrum';
import { createCustomElement, DOMModel, byAttrVal, byJsonAttrVal, registerEvent } from '@adobe/react-webcomponent';
import { useConfigContext } from '../components/ConfigContext/ConfigContext';
import StoreConfigButton from '../components/StoreConfigButton/StoreConfigButton';
import withRoot from '../components/Root/withRoot';
import useLocale from '../components/common/useLocale';

const ContextWrapper = props => {
    const locale = useLocale();
    const [configs] = useConfigContext();

    return (
        <Provider theme={defaultTheme} colorScheme="light" locale={locale}>
            <StoreConfigButton {...props} configs={configs} />
        </Provider>
    );
};

class StoreConfigButtonModel extends DOMModel {
    @byJsonAttrVal() configs;
    @byAttrVal() tooltip;
    @registerEvent('fetch') fetch;
    @byAttrVal() label;
}

(function () {
    const StoreConfigButtonElement = createCustomElement(withRoot(ContextWrapper), StoreConfigButtonModel, 'element');
    const elemName = 'store-config-button';
    if (!window.customElements.get(elemName)) {
        window.customElements.define(elemName, StoreConfigButtonElement);
    }
})();
